import Resource from './resource.js'
// カートサービスをリソースで拡張する
class ContactService extends Resource {
  // コンストラクタ
  constructor() {
    // このURLをresource.jsに対して渡して使っている。
    super('services/contact')
  }
}
// なにかいろいろ拡張されたカートサービスにした。
export default new ContactService()
